import type { DanceSeoHead } from "../danceSeoTypes.js";

// nl translation of shared/danceSeoHeads/en.ts; numbers and claims must stay in sync with the English source.
const head: DanceSeoHead = {
  director: {
    title: "AI-dansvideogenerator op basis van muziek – gratis starten",
    description:
      "Maak van elk nummer een volledige AI-dansvideo. Solmi plant de choreografie per sectie, maakt een storyboard en rendert dans- en lip-sync-shots. Gratis starten.",
    h1: "AI-dansvideogenerator – maak van elk nummer een dansvideo",
  },
  photo: {
    title: "Foto laten dansen – AI-dansgenerator voor foto's | Solmi",
    description:
      "Laat een foto dansen met AI: upload een foto van top tot teen, kies een move of je eigen dansclip en een nummer. Solmi zet de dans op de beat. Gratis starten.",
    h1: "Foto laten dansen – AI-dansgenerator voor foto's",
  },
  inbound:
    "Wil je dat de performer danst? De [AI-dansvideogenerator](/ai-dance-video-generator) plant de choreografie voor elke sectie van je nummer en rendert een volledige dansvideo.",
};

export default head;
